import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import PageHero from "../components/PageHero";
import { useReveal } from "../lib/motion";

function Icon({ name, className, style }) {
    const I = Icons[name] || Icons.Circle;
    return <I className={className} style={style} />;
}

export default function Features() {
    const [features, setFeatures] = useState([]);
    useReveal([features.length]);

    useEffect(() => {
        api.get("/features").then((r) => setFeatures(r.data)).catch(console.error);
    }, []);

    return (
        <div data-testid="features-page">
            <PageHero
                testId="features-hero"
                overline="Every feature"
                title={
                    <>
                        A toolkit for <span className="italic font-light">every season</span> of womanhood.
                    </>
                }
                subtitle="Femcare brings together cycle tracking, fertility science, pregnancy support, AI insights, and community — into one beautifully calm app."
                size="lg"
            />

            <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    {features.map((f, i) => (
                        <div
                            key={f.id}
                            className={`bento-tile p-8 md:p-10 group reveal reveal-delay-${(i % 4) + 1}`}
                            data-testid={`feature-detail-${f.title.toLowerCase().replace(/ /g,'-')}`}
                        >
                            <div className="flex items-start gap-6">
                                <div
                                    className="w-16 h-16 rounded-full flex items-center justify-center shrink-0 transition-transform group-hover:scale-110"
                                    style={{ backgroundColor: `${f.color}22` }}
                                >
                                    <Icon name={f.icon} className="w-7 h-7" style={{ color: f.color }} />
                                </div>
                                <div>
                                    <p className="text-xs uppercase tracking-[0.3em] text-femcare-accent mb-2">
                                        Feature {String(i + 1).padStart(2, "0")}
                                    </p>
                                    <h3 className="font-serif text-2xl md:text-3xl text-femcare-purple mb-3 leading-tight">
                                        {f.title}
                                    </h3>
                                    <p className="text-femcare-purple/70 leading-relaxed">{f.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="max-w-5xl mx-auto px-6 lg:px-12 pb-24 text-center reveal">
                <h2 className="editorial-headline text-3xl md:text-5xl text-femcare-purple mb-6">
                    Ready when <span className="italic font-light">you</span> are.
                </h2>
                <Link to="/pricing" className="btn-primary magnet" data-testid="features-cta">
                    See plans
                    <ArrowRight className="w-4 h-4" />
                </Link>
            </section>
        </div>
    );
}
